<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <div >
            <div class="m-portlet m-b-10" :style="{'height':(100)+'px'}">
                <div class="m-portlet__body">
                    <el-form label-width="100px" style="width: 1000px">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="班主任">
                                    <el-select v-model="headTeacher_id"  placeholder="请选择班主任" filterable remote clearable
                                               @change="handleIndex()">
                                        <el-option
                                                v-for="item in headTeachers"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="月份">
                                    <el-date-picker
                                            v-model="date"
                                            type="month"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择月"
                                            @change="handleIndex()">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="m-portlet m-b-0" :style="{'height':(clientHeight-210)+'px'}">
                <div class="m-portlet__body" v-loading="loading">
                    <el-table
                            :data="studentClassHours"
                            style="width: 100%"
                            :height="clientHeight-350"
                            border
                            size="middle">
                        <el-table-column prop="id" label="编号" align="center" min-width="2%"></el-table-column>
                        <el-table-column prop="student_name" label="姓名" align="center"  min-width="5%"></el-table-column>
                        <el-table-column prop="grade_name" label="年级" align="center"  min-width="5%"></el-table-column>
                        <el-table-column prop="all_classHour" label="总课次" align="center"   min-width="5%"></el-table-column>
                        <el-table-column prop="has_classHour" label="剩余课次" align="center"  min-width="5%"></el-table-column>
                        <el-table-column v-for="(item, index) in studentClassHours[0].date_msgs" min-width="2%" :key="index">
                            <template slot="header" slot-scope="scope">
                                {{item.simple_date}}
                            </template>
                            <template slot-scope="scope">
                                <div v-if="scope.row.date_msgs[index].finished_period>0" style="color:green">
                                    {{scope.row.date_msgs[index].finished_period}}
                                </div>
                                <div v-else style="color:blue">
                                    {{scope.row.date_msgs[index].active_period}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                path:"/onlineStudentClassHour/list",
                headTeacher_id:'',
                date:this.$moment().format('YYYY-MM-DD'),
                headTeachers:[

                ],
                studentClassHours:[ {
                    student_name:'',
                    grade_name:'',
                    all_classHour:'',
                    has_classHour:'',
                    date_msgs:[{
                        date:'',
                        simple_date:'',
                        finished_period:'',
                        active_period:'',
                    }],
                },],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                loading:false,
            };
        },
        mounted() {
        },
        created() {
            this.handleCreate();
            this.handleIndex();
            this.handleShow();
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.headTeachers =data.headTeachers;
                        break;
                    case 'list':
                        this.total = data.total;
                        if(data.datas.length>0){
                            this.studentClassHours = data.datas;
                        }else{
                            this.studentClassHours =[ {
                                student_name:'',
                                grade_name:'',
                                all_classHour:'',
                                has_classHour:'',
                                date_msgs:[{
                                    date:'',
                                    simple_date:'',
                                    finished_period:'',
                                    active_period:'',
                                }],
                            },]
                        }

                        this.loading = false;
                        break;
                }
            },
            handleIndex(currentPage = 1) {
                this.loading = true;
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'date': this.date,
                    'headTeacher_id': this.headTeacher_id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>